
import {defineComponent} from 'vue';
import Calendar from 'primevue/calendar';

export default defineComponent({
  name: "DatePicker",
  components: {Calendar},
  data() {
    return {selected: this.value}
  },
  props: {
    name: {type: String, require: true},
    value: {type: String, required: true},
  },
  computed: {
    yearRange() {
      return "1800:" + (new Date().getFullYear()).toString()
    }
  },
  watch: {
    selected() {
      console.log(this.selected, 'asdasdas')

        this.$emit('select', {key: this.name, value: this.selected})
    },
  }
})
